var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "#9392AD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36665 7L9.38887 9.8H7.65554L6.49999 8.1998L5.34443 9.8H3.6111L5.63332 7L3.6111 4.2H5.34443L6.49999 5.8002L7.65554 4.2H8.66665V1.4H1.44444V12.6H11.5555V4.2H9.38887L7.36665 7ZM0 0.6944C0 0.3108 0.322833 0 0.720776 0H9.38887L13 3.5V13.2944C13.0007 13.3864 12.9828 13.4776 12.9471 13.5629C12.9115 13.6481 12.8589 13.7257 12.7923 13.7913C12.7257 13.8568 12.6464 13.909 12.559 13.9448C12.4716 13.9806 12.3777 13.9994 12.2828 14H0.717165C0.527494 13.9987 0.345956 13.9252 0.211768 13.7952C0.0775795 13.6653 0.0015128 13.4894 0 13.3056V0.6944Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.817e2431319a883bf888a133c9444374.svg";
export { ForwardRef as ReactComponent };